import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ImageFragment } from '../types/graphqlTypes';
import { Img } from './Img';
import { Typography } from './Typography';

const StyledCaption = styled(Typography)`
  ${({ theme: { space } }) => css`
    margin-top: ${space.md};
  `};
`;

export const Image: FC<Omit<ImageFragment, '__typename'>> = ({ image, caption, ...rest }) => {
  if (!image) {
    return null;
  }
  return (
    <figure {...rest}>
      {image && <Img src={image} />}

      {caption && (
        <StyledCaption component="figcaption" variant="smallprint">
          {caption}
        </StyledCaption>
      )}
    </figure>
  );
};
